/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.37.0
 * @since 1.37.0
 */

import { IWizardChangeRoleReducer } from './wizardChangeRoleReducer';

export enum EWizardChangeRoleSteps {
    StepSelectParams = 'ChangeRolePrepareStep',
    StepConfirmation = 'ChangeRoleConfirmStep',
}

export enum EWizardChangeRoleFieldList {
    DELETE = 'delete',
    MSISDN = 'msisdn',
}

export enum EWizardChangeRoleRoleConstants {
    ABSENT = -1,
}

export const initWizardChangeRoleState: IWizardChangeRoleReducer = {
    selectedAccessLevel: {
        id: 0,
        def: '',
    },
    subsAccessLevels: [],
    orderResult: {
        orderSubs: [],
    },
    subscriberIds: [],
    removedSubscribers: [],
    validation: {
        error: '',
        isValid: false,
    },
};

/*
* -------------------------------------------
*           ACTIONS
* -------------------------------------------
*/

export const WIZARD_CHANGE_ROLE_HANDLE_NEXT = '@@b2b_portal_ui/wizardChangeRole/WIZARD_CHANGE_ROLE_HANDLE_NEXT';

export const WIZARD_CHANGE_ROLE_SET_PARAMS = '@@b2b_portal_ui/wizardChangeRole/WIZARD_CHANGE_ROLE_SET_PARAMS';

export const WIZARD_CHANGE_ROLE_START_VALIDATE = '@@b2b_portal_ui/wizardChangeRole/WIZARD_CHANGE_ROLE_START_VALIDATE';
export const WIZARD_CHANGE_ROLE_SET_STEP_VALID = '@@b2b_portal_ui/wizardChangeRole/WIZARD_CHANGE_ROLE_SET_STEP_VALID';
